import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {ProjectExpirationDateField} from '@/features/projects/components/project-form/project-expiration-date-fields/ProjectExpirationDateField'
import {ProjectDurationField} from '@/features/projects/components/project-form/project-expiration-date-fields/ProjectDurationField'
import {ProjectWorkingDays} from '@/features/projects/components/project-form/project-expiration-date-fields/ProjectWorkingDays'

export const ProjectExpirationDateFields = () => {
    return (
        <Grid columns={3} gap={4} fullWidth>
            <ProjectExpirationDateField />
            <ProjectDurationField />
            <ProjectWorkingDays />
        </Grid>
    )
}
